<kendo-dialog
  [minWidth]="250"
  [width]="layoutState.isMobile ? '100%' : '35%'"
  [height]="'90%'"
  *ngIf="opened"
  class="hidden-stepper"
>
  <div class="row text-end close-popup">
    <i (click)="close()" class="ph ph-x"></i>
  </div>
  <div class="row">
    <kendo-stepper
      [steps]="steps"
      [(currentStep)]="currentStepIndex"
      [linear]="false"
      class="carousel-stepper"
    >
    </kendo-stepper>

    <div class="carousel-content">
      <ng-container *ngFor="let slide of slides; let i = index">
        <div *ngIf="i === currentStepIndex" class="carousel-slide">
          <img [src]="slide.image" [alt]="slide.title" />
        </div>
      </ng-container>
    </div>

    <div class="carousel-buttons" *ngIf="slides.length > 1">
      <button
        kendoButton
        [disabled]="currentStepIndex === 0"
        (click)="prevStep()"
        size="large"
        fillMode="none"
      >
        <i class="ph ph-caret-left"></i>
      </button>
      <button
        kendoButton
        [disabled]="currentStepIndex === slides.length - 1"
        (click)="nextStep()"
        size="large"
        fillMode="none"
      >
        <i class="ph ph-caret-right"></i>
      </button>
    </div>
  </div>
</kendo-dialog>
